import { ICreateTourBooking } from '@/types/interface';
import { apiClient } from './apiService';
import { handleLocalStorage } from '@/utils/handleLocalStorage';
import { trackTourBookingComplete } from '@/utils/gtag';

const getToken = () => {
  return handleLocalStorage.get('accessToken');
};

export const tourBookingService = {
  createBooking(data: ICreateTourBooking) {
    return apiClient
      .request({
        method: 'POST',
        url: '/booking_tour/create_tour_order',
        data,
      })
      .then(response => {
        // Track successful tour booking completion
        if (response.data && response.data.id) {
          trackTourBookingComplete(
            response.data.id,
            data.tourId,
            data.contactInfo?.phone ? 0 : 0, // Will be updated with actual pricing
            'VND',
          );
        }
        return response;
      });
  },

  getTourDetail(locale: string, code: string) {
    return apiClient.request({
      method: 'GET',
      url: `/booking_tour/${locale}/order/${code}/tour_detail`,
    });
  },

  createBookingByPartner(data: ICreateTourBooking) {
    return apiClient
      .request({
        method: 'POST',
        url: '/booking_tour/create_tour_order',
        data,
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      })
      .then(response => {
        // Track successful tour booking completion
        if (response.data && response.data.id) {
          trackTourBookingComplete(
            response.data.id,
            data.tourId,
            data.contactInfo?.phone ? 0 : 0, // Will be updated with actual pricing
            'VND',
          );
        }
        return response;
      });
  },

  updatePaymentType(orderId: string, data: { paymentType: string }) {
    return apiClient.request({
      method: 'POST',
      url: `/orders/${orderId}/update_payment_type`,
      data,
    });
  },

  createPaypalPayment(id: string) {
    return apiClient.request({
      method: 'POST',
      url: `/payments/${id}/create-paypal-payment`,
    });
  },

  capturePaypalPayment(id: string) {
    return apiClient.request({
      method: 'POST',
      url: `/payments/${id}/capture-paypal-payment`,
    });
  },
};
